"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import Link from "next/link";
import { usePathname } from "next/navigation";
import { SidebarGroup, SidebarMenu, SidebarMenuButton, SidebarMenuItem, SidebarSeparator } from "@/components/ui/sidebar";
import { PROTECTED_WORKSPACE_VIEWS } from "@/lib/constants/protected-workspace-views";
import { cn } from "@/lib/utils";
import { getViewIcon } from "@/lib/utils/icons";
import type { View } from "@/types/workspace";
const WORKFLOW_VIEW_ORDER = PROTECTED_WORKSPACE_VIEWS.filter(view => view.section === "workflows").map(view => view.name.toLowerCase());
function sortWorkflowViews(views: View[]): View[] {
  return views.toSorted((firstView, secondView) => {
    const firstIndex = WORKFLOW_VIEW_ORDER.indexOf(firstView.name.toLowerCase());
    const secondIndex = WORKFLOW_VIEW_ORDER.indexOf(secondView.name.toLowerCase());
    return firstIndex - secondIndex;
  });
}
interface WorkspaceMenuWorkflowsSectionProps {
  canViewAutomations: boolean;
  menuButtonClassName: string;
  onNavigate: (url: string) => void;
  open: boolean;
  views: View[];
  workspaceId: string;
}
export function WorkspaceMenuWorkflowsSection(t0) {
  const $ = _c(34);
  const {
    canViewAutomations,
    menuButtonClassName,
    onNavigate,
    open,
    views,
    workspaceId
  } = t0;
  const pathname = usePathname();
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== canViewAutomations || $[1] !== menuButtonClassName || $[2] !== onNavigate || $[3] !== open || $[4] !== pathname || $[5] !== views || $[6] !== workspaceId) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const sortedViews = sortWorkflowViews(views);
      if (!canViewAutomations || sortedViews.length === 0) {
        t4 = null;
        break bb0;
      }
      const t5 = open ? "Workflows" : "Flows";
      let t6;
      if ($[13] !== t5) {
        t6 = <p className="text-xs font-medium text-sidebar-border/90 shrink-0 text-shadow-md text-shadow-sidebar-accent/30">{t5}</p>;
        $[13] = t5;
        $[14] = t6;
      } else {
        t6 = $[14];
      }
      let t7;
      if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = <SidebarSeparator className="mx-0 bg-sidebar-border/20" />;
        $[15] = t7;
      } else {
        t7 = $[15];
      }
      if ($[16] !== t6) {
        t3 = <div className="flex items-center px-2 gap-2 -mb-2">{t6}{t7}</div>;
        $[16] = t6;
        $[17] = t3;
      } else {
        t3 = $[17];
      }
      T1 = SidebarGroup;
      t2 = "gap-1";
      T0 = SidebarMenu;
      let t8;
      if ($[18] !== menuButtonClassName || $[19] !== onNavigate || $[20] !== open || $[21] !== pathname || $[22] !== workspaceId) {
        t8 = view => {
          const url = `/${workspaceId}/${view.name.toLowerCase()}`;
          const isActive = pathname.toLowerCase().startsWith(url);
          const ViewIcon = getViewIcon(view.name);
          return <SidebarMenuItem key={view.id}><SidebarMenuButton asChild={true} className={cn(menuButtonClassName, !open && "border-l-0!")} isActive={isActive} tooltip={{
              arrow: {
                className: "fill-sidebar-accent"
              },
              children: view.name,
              className: "bg-sidebar-accent text-sidebar-accent-foreground"
            }}><Link href={url} onClick={() => {
                onNavigate(url);
              }} prefetch={false}>{ViewIcon && <ViewIcon />}<span>{view.name}</span></Link></SidebarMenuButton></SidebarMenuItem>;
        };
        $[18] = menuButtonClassName;
        $[19] = onNavigate;
        $[20] = open;
        $[21] = pathname;
        $[22] = workspaceId;
        $[23] = t8;
      } else {
        t8 = $[23];
      }
      t1 = sortedViews.map(t8);
    }
    $[0] = canViewAutomations;
    $[1] = menuButtonClassName;
    $[2] = onNavigate;
    $[3] = open;
    $[4] = pathname;
    $[5] = views;
    $[6] = workspaceId;
    $[7] = T0;
    $[8] = T1;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    T0 = $[7];
    T1 = $[8];
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[24] !== T0 || $[25] !== t1) {
    t5 = <T0>{t1}</T0>;
    $[24] = T0;
    $[25] = t1;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  let t6;
  if ($[27] !== T1 || $[28] !== t2 || $[29] !== t5) {
    t6 = <T1 className={t2}>{t5}</T1>;
    $[27] = T1;
    $[28] = t2;
    $[29] = t5;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  let t7;
  if ($[31] !== t3 || $[32] !== t6) {
    t7 = <>{t3}{t6}</>;
    $[31] = t3;
    $[32] = t6;
    $[33] = t7;
  } else {
    t7 = $[33];
  }
  return t7;
}